/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MiscStats/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaProfileValueWithLabelText from 'DesignSystem/TysiaProfileElements/TysiaProfileValueWithLabelText/index'



/** @type {import('Simple/types.js').View} */
export default function MiscStats({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Detail/Content/MiscStats"
  
}) {
let selectedLeadLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.location.name',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let selectedLeadUpdatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'lead.updated_at',
format: fromFormat.dateISOToDateAndTime,
})
  return (<React.Fragment
>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 marginTop={dtSpaceXxs}
 isHorizontal={true}
 label="Location"
 data="selected.lead.location.name"
 value={selectedLeadLocationNameValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 marginTop={0}
 isHorizontal={true}
 label="Last Seen"
 data="selected.lead.updated_at"
 format="/Data/format.js dateISOToDateAndTime"
 value={selectedLeadUpdatedAtValueData}
/>
{children}
</React.Fragment>)
}